import Cookies from 'js-cookie';
import _debounce from 'lodash-es/debounce';
import { axiosClient } from '~/common/js/axios';
import {
	insertSignToParams,
	isLoginedToken,
	gotoLogin,
	breakDownHostUrl,
	transRouteLang,
} from '~/common/js/utils';
import { COMMON_ROUTES_MAP, AUTH_ROUTES_MAP } from './config';
import { FUTURES_COMMON_ROUTES_MAP } from './futures-config';
import { LOCALE_MAP, REVERSE_LOCALE_MAP } from '~/frontend-shared/helper/const'
import { useStore } from '~/common/js/patch';
import { transLang } from '~/common/js/storeUtil'
// @TODO 规则，所有的通用属性和方法，属性和方法都会通过$$为前缀标识
export default {
	data() {
		return {
			store: useStore()
		};
	},
	computed: {
		$$locale() {
			return this.store?.locale;
		},
		kycLevel() {
			return this.store?.account?.kycLevel;
		},
		agentType() {
			return this.store?.account.agentType;
		},
		isSubAccount() {
			return this.store?.getters['account/isSubAccount'];
		},
		isSubAccountExcludNull() {
			return this.store?.getters['account/isSubAccountExcludNull'];
		},
		$$transLocale() {
			return transLang(this.store?.locale);
		},
		$$transRouteLocale (state) {
			return transRouteLang(this.store?.locale)
		},
		// ...mapGetters({
		// 	isSubAccount: 'account/isSubAccount',
		// 	isSubAccountExcludNull: 'account/isSubAccountExcludNull',
		// }),


		$$FUTURES_ROUTES_CONFIG() {
			// 合约配置
			return [
				{
					show: true,
					type: 'group',
					value: 'trade',
					iconName: 'menu',
					name: 'bmui-navigator-bar.group_route_trade',
					list: [
						// {
						// 	show: true,
						// 	...COMMON_ROUTES_MAP.get('TRADE.STANDARD'),
						// 	to: {
						// 		...COMMON_ROUTES_MAP.get('TRADE.STANDARD').to,
						// 		query: {
						// 			...COMMON_ROUTES_MAP.get('TRADE.STANDARD').to.query,
						// 			symbol: this.$route.name === 'trade-lang' ? this.$route.query.symbol : null,
						// 			theme: this.$route.name === 'trade-lang' ? this.$route.query.theme : null,
						// 		},
						// 	},
						// },
						{
							show: true,
							...COMMON_ROUTES_MAP.get('TRADE.ADVANCED'),
							to: {
								...COMMON_ROUTES_MAP.get('TRADE.ADVANCED').to,
								query: {
									...COMMON_ROUTES_MAP.get('TRADE.ADVANCED').to.query,
									symbol: this.$route.name === 'trade-lang' ? this.$route.query.symbol : null,
									theme: this.$route.name === 'trade-lang' ? this.$route.query.theme : null,
								},
							},
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('TRADE.MARGIN'),
						},
					],
				},
				{
					show: true,
					type: 'single',
					...FUTURES_COMMON_ROUTES_MAP.get('HOME'),
				},
				{
					show: true,
					type: 'single',
					...FUTURES_COMMON_ROUTES_MAP.get('FUTURES_USDT'),
				},
				{
					show: true,
					type: 'single',
					...FUTURES_COMMON_ROUTES_MAP.get('FUTURES_COIN'),
				},
				{
					show: true,
					type: 'single',
					...FUTURES_COMMON_ROUTES_MAP.get('FUTURES_COPY'),
				},
				{
					show: true,
					type: 'single',
					...FUTURES_COMMON_ROUTES_MAP.get('FUTURES_INFO'),
				},
				// {
				// 	show: true,
				// 	hot: true,
				// 	type: 'single',
				// 	...FUTURES_COMMON_ROUTES_MAP.get('LUNAR-NEW-YEAR'),
				// },
				{
					show: true,
					type: 'single',
					...COMMON_ROUTES_MAP.get('EVENTSCENTER'),
				},
				// {
				// 	show: true,
				// 	type: 'group',
				// 	hot: true,
				// 	value: 'promotion',
				// 	name: 'bmui-navigator-bar.group_route_promotion',
				// 	list: [
				// 		{
				// 			show: true,
				// 			type: 'single',
				// 			...COMMON_ROUTES_MAP.get('EVENTSCENTER'),
				// 		},
				// 		{
				// 			show: true,
				// 			type: 'single',
				// 			...COMMON_ROUTES_MAP.get('BONUSGIVEAWAY'),
				// 		},
				// 	],
				// },
			];
		},
		$$COMMON_ROUTES_CONFIG() {
			// 现货配置
			// 不疯页面是否展示
			return [
				{
					show: true,
					type: 'group',
					value: 'BUY_CRYPTO',
					name: 'bmui-navigator-bar.group_route_buy',
					list: [
						{ show: true, ...COMMON_ROUTES_MAP.get('P2P') },
						{ show: true, ...COMMON_ROUTES_MAP.get('PAYMENT_3RD') },
					],
				},

				{
					show: true,
					type: 'single',
					...COMMON_ROUTES_MAP.get('MARKETS'),
				},
				{
					show: true,
					type: 'group',
					value: 'trade',
					name: 'bmui-navigator-bar.group_route_trade',
					list: [
						// {
						// 	show: true,
						// 	...COMMON_ROUTES_MAP.get('TRADE.STANDARD'),
						// 	to: {
						// 		...COMMON_ROUTES_MAP.get('TRADE.STANDARD').to,
						// 		query: {
						// 			...COMMON_ROUTES_MAP.get('TRADE.STANDARD').to.query,
						// 			symbol: this.$route.name === 'trade-lang' ? this.$route.query.symbol : null,
						// 			theme: this.$route.name === 'trade-lang' ? this.$route.query.theme : null,
						// 		},
						// 	},
						// },
						{
							show: true,
							...COMMON_ROUTES_MAP.get('TRADE.ADVANCED'),
							to: {
								...COMMON_ROUTES_MAP.get('TRADE.ADVANCED').to,
								query: {
									...COMMON_ROUTES_MAP.get('TRADE.ADVANCED').to.query,
									...this.$route.query,
									type: null,
								},
							},
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('TRADE.MARGIN'),
							to: {
								...COMMON_ROUTES_MAP.get('TRADE.MARGIN').to,
								query: {
									...COMMON_ROUTES_MAP.get('TRADE.MARGIN').to.query,
									...this.$route.query,
								},
							},
						},
					],
				},

				{
					show: true,
					type: 'group',
					value: 'futures',
					name: 'bmui-navigator-bar.group_route_futures',
					list: [
						{
							show: true,
							...COMMON_ROUTES_MAP.get('FUTURES.MAIN'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('TRADE.FUTURES_USDT'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('TRADE.FUTURES_COIN'),
						},
						// {
						// 	show: true,
						// 	...COMMON_ROUTES_MAP.get('TRADE.FUTURES_COPY'),
						// },
					],
				},

				{
					show: true,
					type: 'single',
					...COMMON_ROUTES_MAP.get('FUTURES_COPY'),
				},

				{
					show: true,

					type: 'group',
					value: 'earn',
					name: 'bmui-navigator-bar.group_route_earn',
					list: [
						{
							show: true,
							...COMMON_ROUTES_MAP.get('EARN.SAVINGS'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('EARN.STAKING'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('EARN.DUAL'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('EARN.ETH2'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('EARN.VIP_SAVINGS'),
						},
					],
				},
				{
					show: true,
					type: 'group',
					value: 'nft',
					name: 'bmui-navigator-bar.group_route_nft',
					list: [
						{
							show: true,
							type: 'single',
							...COMMON_ROUTES_MAP.get('NFT.MARKET'),
						},
						{
							show: true,
							type: 'single',
							...COMMON_ROUTES_MAP.get('NFT.INO'),
						},
					],
				},
				{
					show: true,
					type: 'group',
					value: 'more',
					name: 'bmui-navigator-bar.group_route_more',
					columns: true,
					list: [
						{
							show: true,
							...COMMON_ROUTES_MAP.get('LAUNCHPAD'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('VOTING'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('INSTITUTION'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('APIS'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('VIP'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('REFERRAL'),
						},
						// {
						//   show: false,
						//   ...COMMON_ROUTES_MAP.get('PARTNER'),
						// },
						{
							show: true,
							...COMMON_ROUTES_MAP.get('AFFILIATE'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('BROKER'),
						},

						{
							show: true,
							...COMMON_ROUTES_MAP.get('TASK'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('LEARN2EARN'),
						},
						{
							show: true,
							...COMMON_ROUTES_MAP.get('ACADEMY'),
						},
					],
				},
				// {
				// 	show: true,
				// 	type: 'single',
				// 	...COMMON_ROUTES_MAP.get('EVENTSCENTER'),
				// },
				{
					show: true,
					type: 'group',
					hot: true,
					value: 'promotion',
					name: 'bmui-navigator-bar.group_route_promotion',
					list: [
						{
							show: true,
							type: 'single',
							...COMMON_ROUTES_MAP.get('EVENTSCENTER'),
						},
					],
				},
			];
		},

		$$AUTH_ROUTES_CONFIG() {
			return [
				{ show: true, ...AUTH_ROUTES_MAP.get('ASSETS') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ORDERS') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ACCOUNT.OVERVIEW') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ACCOUNT.SECURITY') },
				{
					show: !this.isSubAccount && this.kycLevel === 10,
					...AUTH_ROUTES_MAP.get('ACCOUNT.INSTITUTION_VERIFICATION'),
				},
				{
					show: !this.isSubAccount && this.kycLevel !== 10,
					...AUTH_ROUTES_MAP.get('ACCOUNT.VERIFICATION'),
				},
				// { show: true, ...AUTH_ROUTES_MAP.get('ACCOUNT.TASK') },
				// { show: !this.isSubAccount, ...AUTH_ROUTES_MAP.get('ACCOUNT.REFERRAL') },
				{ show: !this.isSubAccount, ...AUTH_ROUTES_MAP.get('ACCOUNT.API') },
				{
					show: this.canUseSubAccount,
					...AUTH_ROUTES_MAP.get('ACCOUNT.SUBACCOUNT'),
				},
				{ show: this.agentType, ...AUTH_ROUTES_MAP.get('ACCOUNT.PARTNER') },
				{ show: true, ...AUTH_ROUTES_MAP.get('ACCOUNT.VOUCHER') },
			];
		},
	},

	methods: {
		$$appendRouteParams(options) {
			if (options === '/') {
				options = '';
			}
			if (options.path === '/') {
				options.path = '';
			}

			if (typeof options === 'string') {
				return `${options}/${this.$$transRouteLocale}`;
			}

			// 移除falsiy值
			const falsiyList = [undefined, null, ''];
			if (options.query) {
				Object.keys(options.query).forEach((key) => {
					if (falsiyList.includes(options.query[key])) {
						delete options.query[key];
					}
				});
			}

			if (options.params) {
				Object.keys(options.params).forEach((key) => {
					if (falsiyList.includes(options.params[key])) {
						delete options.params[key];
					}
				});
			}

			return {
				...options,
				path: `${options.path}/${this.$$transRouteLocale}`,
			};
		},
		// 神策埋点
		$$track(eventName, data) {
			return new Promise((resolve, reject) => {
				try {
					window.sensors && window.sensors.track(eventName, data);
					resolve();
				} catch (error) {
					reject();
				}
			});
		},
		// 获取用户资产
		$$getUserAssets: _debounce(
			async function () {
				if (!isLoginedToken()) {
					gotoLogin(this.$router, this.$route, this.locale);
					return;
				}

				// const token = Cookies.get('accessToken');
				const salt = Cookies.get('accessSalt');
				const params = {
					timestamp: new Date().getTime(),
				};

				insertSignToParams(params, params.timestamp, salt);

				return await axiosClient({
					method: 'GET',
					url: '/gw-api/asset-gateway/asset/total', // 新用户总资产接口
					params,
					// headers: {
					// 	Authorization: token,
					// },
				});
			},
			1000,
			{
				leading: true,
				trailing: false,
			}
		),
		// 退出登录
		async $$logout() {
			// TODO 3619
			// const token = Cookies.get('accessToken');

			await axiosClient({
				method: 'POST',
				url: '/gw-api/user-center/token/logout',
				// data: {
				// 	token,
				// },
				// headers: {
				// 	Authorization: token,
				// },
			});

			window.sessionStorage.clear();

			// this.$router.push(`/login/${this.$$locale}`)
			this.store.commit('SET_CLEAN_INFO');
			window.location.href = `/login/${this.locale}`;
			// if (!isLoginedToken()) {
			//   gotoLogin(this.$router, this.$route, this.locale)
			//   return
			// }
		},
		// 切换语言
		$$switchLanguage(lang) {
			const cookieOptions = {
				httpOnly: false,
				secure: import.meta.env.VITE_DEBUG !== 'true',
				sameSite: 'Lax',
			};

			const webDomain = breakDownHostUrl(location.host);

			if (!webDomain.includes('localhost')) {
				Object.assign(cookieOptions, {
					domain: `.${webDomain}`,
				});
			}

			const cookieLang = LOCALE_MAP.has(lang) ? LOCALE_MAP.get(lang) : lang;

			Cookies.set('golang', cookieLang, cookieOptions);

			localStorage.setItem('golang', cookieLang);

			const { name, query, params } = this.$route;

			this.$router.push({
				// 可能是健壮写法，暂留
				// @TODO 语种的切换逻辑是否要变更
				name: name === 'index' || name === 'index-lang' ? 'index-lang' : name,
				query,
				params: {
					...params,
					lang: REVERSE_LOCALE_MAP.has(cookieLang) ? REVERSE_LOCALE_MAP.get(cookieLang) : cookieLang,
				},
			});
		},
	},
};
